module.exports = __webpack_public_path__ + "static/media/bouquet-alt.0c26bcf4.svg";